export const ALL_VAULTSV3_KINDS = {
  highlight: 'Featured',
  multi: 'Allocator',
  single: 'Strategy'
}
export const ALL_VAULTSV3_KINDS_KEYS = Object.keys(ALL_VAULTSV3_KINDS)

export const ALL_VAULTSV3_CATEGORIES = {
  Stablecoin: 'Stablecoin',
  Volatile: 'Volatile',
  Holdings: 'Your Holdings',
  Migratable: 'Migratable',
  Retired: 'Retired'
}
export const ALL_VAULTSV3_CATEGORIES_KEYS = Object.keys(ALL_VAULTSV3_CATEGORIES)

export const DEFAULT_SELECTED_VAULTSV3_CATEGORIES: string[] = []
